import React, { useEffect } from "react";
import AssessmentItem from "../Items/AssessmentItem";
import PaginationFooter from "./PaginationFooter";
import { searchGlobalContent } from "common/services/search.service";
import { determineEntityType } from "common/lib/entityType";
import LoadingItem from "../Items/LoadingItem";
import debounce from "debounce";
import { DEBOUNCE_TIME } from "common/constants";
import ResultsNotFound from "../Items/ResultsNotFound";

const tab = "5";

const Assessments = ({
  searchValue,
  activeTab,
}: {
  searchValue: string;
  activeTab: string;
}) => {
  const [searchResults, setSearchResults] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [page, setPage] = React.useState<number>(1);
  const [totalPages, setTotalPages] = React.useState<number>(0);

  useEffect(() => {
    const search = debounce(async () => {
      try {
        setLoading(true);
        const response: any = await searchGlobalContent({
          query: searchValue && searchValue.toLowerCase(),
          pageSize: 20,
          page: page,
          index: "assessment",
        });

        setSearchResults(response.hits);
        setPage(response?.page);
        setTotalPages(response?.totalPages);
        setLoading(false);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }, DEBOUNCE_TIME);

    if (activeTab === tab) {
      search();
    }
    return () => {
      search.clear();
    };
  }, [searchValue, page, activeTab]);

  if (loading) {
    return Array.from({ length: 10 }).map((_, index) => (
      <div key={index}>
        {index !== 0 && <div className="border border-dashed"></div>}
        <LoadingItem key={index} />
      </div>
    ));
  }

  if (searchResults.length === 0) {
    return <ResultsNotFound />;
  }

  return (
    <>
      {searchResults.map((result: any, index: number) => {
        const entityType: string = determineEntityType(result._meilisearch_id);

        if (
          entityType === "risk-assessment" ||
          entityType === "capacity-assessment" ||
          entityType === "partner-verification-report" ||
          entityType === "psea-assessment" ||
          entityType === "assessment"
        ) {
          return (
            <div key={result.id}>
              {index !== 0 && <div className="border border-dashed"></div>}
              <AssessmentItem
                data={result._formatted}
                index={index}
                entityType={entityType}
              />
            </div>
          );
        }
        return null;
      })}
      {/* <div className="border border-dashed"></div> */}

      {/* <AssessmentItem /> */}
      {/* <div className="border border-dashed"></div> */}

      <PaginationFooter
        page={page}
        totalPages={totalPages}
        onPageChange={(page: number) => setPage(page)}
      />
    </>
  );
};

export default Assessments;
